import { PageHeader } from '@/components'
import { RevenueData } from './revenue-data'

export function RevenuePage() {
  return (
    <>
      <PageHeader>Faturamento</PageHeader>
      <RevenueData />
    </>
  )
}
